<script>
import {LegendColorArtifact} from "@/libs/Colors";
import {disposeTooltipsByClass, setupTooltipsByClass} from "@/libs/Helpers";

export default {
  name: 'Legend',
  props: {
    propId: String,
    propUnit: String,
    //Chroma.js function to get color based on value
    propLegendColorArtifact: {type: LegendColorArtifact, default: null},
  },
  watch: {
    propLegendColorArtifact(newValue, oldValue) {
      this.getStepValues()
    }
  },
  computed: {
    minValue() {
      return this.propLegendColorArtifact !== null ? this.propLegendColorArtifact.minValue : null
    },
    minValueLabel() {
      return this.propLegendColorArtifact !== null ? this.propLegendColorArtifact.labelMinValue : ''
    },
    maxValue() {
      return this.propLegendColorArtifact !== null ? this.propLegendColorArtifact.maxValue : null
    },
    maxValueLabel() {
      return this.propLegendColorArtifact !== null ? this.propLegendColorArtifact.labelMaxValue : ''
    },
    colorScaleFunction() {
      //Chroma.js function to get color based on value
      return this.propLegendColorArtifact !== null ? this.propLegendColorArtifact.chromaJSColorFunction : null
    },
    midValue() {
      return this.minValue !== null && this.maxValue !== null ?
          (this.maxValue - this.minValue) / 2 :
          null
    },
    minValueStr() {
      if (this.minValueLabel !== null && this.minValueLabel !== undefined) {
        let value = parseInt(this.minValueLabel);
        if (isNaN(value))
          value = this.minValueLabel;

        return value;
      }
      return '';
    },
    maxValueStr() {
      if (this.maxValueLabel !== null && this.maxValueLabel !== undefined) {
        let value = parseInt(this.maxValueLabel);
        if (isNaN(value))
          value = this.maxValueLabel;

        return value;
      }
      return '';
    },
  },
  data() {
    return {
      stepValues: []
    }
  },
  methods: {
    getStepValues() {
      let minValue = this.minValue;
      let maxValue = this.maxValue;

      let stepValues = [];

      if (minValue !== null && maxValue !== null) {
        //List of 100 points based on minimum and maximum values

        let stepValue = (maxValue - minValue) / 100;
        let currentValue = maxValue;

        while (currentValue >= minValue) {
          stepValues.push(currentValue);
          currentValue -= stepValue;
        }
      }
      this.stepValues = stepValues;
    },
    createTooltip() {
      let tooltipClass = `.tooltip-legend`;
      disposeTooltipsByClass(tooltipClass);
      setupTooltipsByClass(tooltipClass);
    },
  },
  mounted() {
    this.getStepValues();
    this.createTooltip();
  },
  updated() {
    this.createTooltip();
  }
}
</script>
<template>
  <div :id="propId" class="control-layer control-layer-legend legend bg-white-opacity-80">
    <div class="row title align-items-center">
      <div class="col text-center fw-bold">
        {{ propUnit !== null && propUnit !== '' ? propUnit : $t('legend.legend') }}
      </div>
    </div>
    <div class="d-flex content ps-1">
      <div class="h-100 bar">
        <template v-for="item in this.stepValues">
          <i :style="{'background-color': this.colorScaleFunction(item)}" :data-label="item"
             class="tooltip-legend cursor-pointer"
             data-bs-toggle="tooltip"
             :data-bs-title="item.toFixed(1)"
          ></i>
        </template>
      </div>
      <div class="p-0 flex-grow-1">
        <div class="row h-25 align-items-start text-end">
          <div class="col lh-1">
            <span class="small align-text-top">
              {{ this.maxValueStr }}
            </span>
          </div>
        </div>

        <div class="row h-50 align-items-center">
          <div class="col">
            <span class="small">
              &nbsp;
            </span>
          </div>
        </div>

        <div class="row h-25 align-items-end text-end">
          <div class="col lh-1">
            <span class="small align-text-bottom">
              {{ this.minValueStr }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
